// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.l62BMYYTB0mNbD {
  display: block;
  max-width: 100%;
  height: auto;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin: var(--ds-space-250, 18px) auto 42px auto;
}
.L4FOpeeYS0GJBL {
  margin-top: var(--ds-space-500, 40px);
  color: var(--ds-text, #172b4d);
  font-size: 24px;
  letter-spacing: -0.01em;
  line-height: 28px;
  font-weight: var(--ds-font-weight-semibold, 600);
  margin-top: var(--ds-space-0, 0);
  margin-bottom: var(--ds-space-150, 10px);
}
.PYbc7v8hULHxPs {
  margin-bottom: 8px;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding: 16px;
  background-color: var(--ds-background-neutral, #091e420f);
  color: var(--ds-text-subtle, #44546f);
  font-size: 14px;
  line-height: 18px;
  white-space: pre-line;
}
.PYbc7v8hULHxPs a {
  color: var(--ds-link, #0c66e4);
  text-decoration: none;
}
.PYbc7v8hULHxPs a:hover,
.PYbc7v8hULHxPs a:active {
  text-decoration: underline;
}
.GGOLgrJwC4r8BH {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 530px;
  margin: auto;
}
.GGOLgrJwC4r8BH .oLdSBZQS0O6jys {
  color: var(--ds-text-danger, #ae2a19);
  font-size: 14px;
}
.GGOLgrJwC4r8BH .yRZcGLz3Db3p6k {
  margin-top: 28px;
  color: var(--ds-text, #172b4d);
  font-size: 20px;
  letter-spacing: -0.008em;
  line-height: 24px;
  font-weight: var(--ds-font-weight-semibold, 600);
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin-top: 40px;
  font-weight: var(--ds-font-weight-medium, 500);
  line-height: 26px;
}
.GGOLgrJwC4r8BH hr {
  margin-top: var(--ds-space-0, 0);
  /* 16px pixel gap but -1px for the height of the HR */
  margin-bottom: var(--ds-space-200, 15px);
}
.GGOLgrJwC4r8BH .T9dFcNoEW7AX8g {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: var(--ds-space-0, 0);
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin-bottom: 12px;
}
.GGOLgrJwC4r8BH .T9dFcNoEW7AX8g .RV7MZo_bOGcwkS {
  margin-top: var(--ds-space-200, 16px);
  color: var(--ds-text, #172b4d);
  font-size: 14px;
  letter-spacing: -0.003em;
  line-height: 16px;
  font-weight: var(--ds-font-weight-semibold, 600);
  margin-top: var(--ds-space-0, 0);
  margin-bottom: var(--ds-space-0, 0);
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding-top: 16px;
}
.GGOLgrJwC4r8BH .T9dFcNoEW7AX8g .ACWQOyTurgNfqH {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding-top: 16px;
}
.GGOLgrJwC4r8BH .ccm5Q3r9TkVUnt {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-block-start: 8px;
}
.GGOLgrJwC4r8BH .ccm5Q3r9TkVUnt .wW0Y1PPS5pwEq0 {
  display: flex;
  flex: 0 0 100%;
  flex-direction: column;
}
@media only screen and (max-width: 750px) {
  .GGOLgrJwC4r8BH .ccm5Q3r9TkVUnt .wW0Y1PPS5pwEq0 {
    flex: 1;
  }
}
.GGOLgrJwC4r8BH .ccm5Q3r9TkVUnt .AMh8VjtOGiYW6j {
  width: fit-content;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin-top: 40px;
  margin-right: var(--ds-space-0, 0);
  margin-left: auto;
}
.GGOLgrJwC4r8BH .ccm5Q3r9TkVUnt .Lxz6oEyci00Q0e {
  color: var(--ds-text, #172b4d);
  font: var(--ds-font-body, 400 14px / 20px -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-display: swap;
  padding: 8px 12px;
  border-radius: var(--ds-border-radius-100, 3px);
  transition-property: background-color, border-color, box-shadow;
  transition-duration: 85ms;
  transition-timing-function: ease;
  box-sizing: border-box;
  border: none;
  outline: none;
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
  height: 72px;
  margin-bottom: 8px;
  color: var(--ds-text-subtle, #44546f);
  resize: vertical;
}
.GGOLgrJwC4r8BH .ccm5Q3r9TkVUnt .Lxz6oEyci00Q0e:hover {
  background-color: var(--ds-background-input-hovered, #f7f8f9);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
}
.GGOLgrJwC4r8BH .ccm5Q3r9TkVUnt .Lxz6oEyci00Q0e:focus {
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #388bff);
}
.GGOLgrJwC4r8BH .ccm5Q3r9TkVUnt .Lxz6oEyci00Q0e:disabled {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: none;
  color: var(--ds-text-disabled, #091e424f);
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
}
.GGOLgrJwC4r8BH .ccm5Q3r9TkVUnt .Lxz6oEyci00Q0e[readonly] {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: inset 0 0 0 2px var(--ds-border-input, #091e4224);
}
.GGOLgrJwC4r8BH .ccm5Q3r9TkVUnt .Lxz6oEyci00Q0e.RXy69pK2KTZflO {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.GGOLgrJwC4r8BH .ccm5Q3r9TkVUnt .Lxz6oEyci00Q0e.RXy69pK2KTZflO:hover {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.GGOLgrJwC4r8BH .ccm5Q3r9TkVUnt .Lxz6oEyci00Q0e.RXy69pK2KTZflO:focus {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.GGOLgrJwC4r8BH .ccm5Q3r9TkVUnt .Lxz6oEyci00Q0e.bLnQl0mtpCmys6 {
  width: 100%;
}
.GGOLgrJwC4r8BH .ccm5Q3r9TkVUnt .Lxz6oEyci00Q0e::placeholder {
  color: var(--ds-text-subtlest, #626f86);
}
.GGOLgrJwC4r8BH .ccm5Q3r9TkVUnt .Lxz6oEyci00Q0e:hover {
  background: var(--ds-background-input, #ffffff);
}
.GGOLgrJwC4r8BH .ccm5Q3r9TkVUnt .Lxz6oEyci00Q0e:focus {
  color: var(--ds-text, #172b4d);
}
.GGOLgrJwC4r8BH .vey9Wx_I0Gq9rg {
  margin-bottom: var(--ds-space-200, 16px);
}
.Q9JuZAX8My7P2y {
  padding-inline-start: var(--ds-space-025, 2px);
  color: var(--ds-text-danger, #de350b);
}
@media screen and (max-width: 530px) {
  .GGOLgrJwC4r8BH .ccm5Q3r9TkVUnt {
    flex-direction: column;
  }
}
`, ""]);
// Exports
export var tacoPrivacy = `l62BMYYTB0mNbD`;
export var profileHeader = `L4FOpeeYS0GJBL`;
export var legalText = `PYbc7v8hULHxPs`;
export var memberProfileTabContainer = `GGOLgrJwC4r8BH`;
export var error = `oLdSBZQS0O6jys`;
export var sectionHeader = `yRZcGLz3Db3p6k`;
export var inputLabel = `T9dFcNoEW7AX8g`;
export var text = `RV7MZo_bOGcwkS`;
export var privacyLabel = `ACWQOyTurgNfqH`;
export var aboutContent = `ccm5Q3r9TkVUnt`;
export var leftColumn = `wW0Y1PPS5pwEq0`;
export var profileSaveButton = `AMh8VjtOGiYW6j`;
export var bioTextArea = `Lxz6oEyci00Q0e`;
var _1 = `RXy69pK2KTZflO`;
export { _1 as "input-error" };
export var full = `bLnQl0mtpCmys6`;
export var profileSyncSectionMessage = `vey9Wx_I0Gq9rg`;
export var requiredAsterisk = `Q9JuZAX8My7P2y`;
export default ___CSS_LOADER_EXPORT___;
